(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elova-product-card"] && !Shopify.designMode) return;
  try {
    class ElovaProductCard extends HTMLElement {
    connectedCallback() {
      // Product-card -> PDP image transition. Same mechanism as Horizon's own
      // card: mark this card's gallery with data-view-transition-type and
      // data-view-transition-triggered on click, and let base.css apply
      // `view-transition-name: product-image-transition` while a transition of
      // that type is active. assets/view-transitions.js strips the attribute
      // from any element that was NOT triggered, on pageswap.
      //
      // The one thing that cannot be mirrored is the wiring. Horizon writes
      // `on:click="/handleViewTransition"`, which only resolves on a subclass
      // of its Component base; this card extends plain HTMLElement and has no
      // refs/on: machinery, so the listener is bound here instead. The
      // attributes, the name and the cleanup contract are identical.
      if (this.dataset.productTransition === 'true') {
        this.addEventListener('click', this.handleViewTransition.bind(this));
      }

      this.button = this.querySelector('.elova-product-card__quick-add');
      this.live = this.querySelector('[data-quick-add-live]');
      if (!this.button) return;
      this.button.addEventListener('click', this.handleClick.bind(this));
      this.successText = this.dataset.successText || '';
      this.errorText = this.dataset.errorText || '';
    }

    // Guards mirrored from ProductCard#handleViewTransition in
    // assets/product-card.js (Horizon core).
    handleViewTransition(event) {
      // Another component is handling this click.
      if (event.defaultPrevented) return;

      // Not a navigation - quick-add and other controls own their own clicks.
      if (event.target instanceof Element) {
        if (event.target.closest('button, input, label, select, [tabindex="1"]')) return;
      }

      const gallery = this.querySelector('[data-view-transition-to-main-product]');
      if (!gallery) return;

      gallery.setAttribute('data-view-transition-type', 'product-image-transition');
      gallery.setAttribute('data-view-transition-triggered', 'true');
    }

    async handleClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const variantId = this.button.dataset.variantId;
      if (!variantId || this.button.dataset.state === 'loading') return;

      this.button.dataset.state = 'loading';
      try {
        // Collect every <cart-items-component> section id so Horizon can morph the
        // drawer and the cart page off the single /cart/add.js response (same pattern
        // as theme/assets/product-form.js #processBatchAddToCart).
        const sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach((node) => {
          const id = node.dataset && node.dataset.sectionId;
          if (id && !sectionIds.includes(id)) sectionIds.push(id);
        });

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: sectionIds.join(','),
          }),
        });
        if (!addRes.ok) throw new Error(addRes.statusText);
        const addPayload = await addRes.json();

        // Re-fetch the cart so detail.resource.item_count is authoritative — the
        // drawer's #handleCartAdd reads event.detail.resource.item_count for the
        // a11y count announcement, and cart-icon SETs the bubble from
        // detail.data.itemCount when source !== 'product-form-component'.
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = cartRes.ok ? await cartRes.json() : null;
        const itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

        this.button.dataset.state = 'success';
        if (this.live) this.live.textContent = this.successText;

        // Horizon contract: CartAddEvent.eventName === ThemeEvents.cartUpdate ('cart:update').
        // Listeners: cart-drawer-component (auto-open + announce), cart-icon (bubble),
        // cart-items-component (morph). All bound on `document`.
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id || 'elova-quick-add',
              data: {
                source: 'elova-quick-add',
                itemCount: itemCount,
                productId: this.dataset.productId,
                variantId: variantId,
                sections: addPayload && addPayload.sections,
              },
            },
          }),
        );

        setTimeout(() => {
          this.button.dataset.state = '';
        }, 1600);
      } catch (err) {
        this.button.dataset.state = 'error';
        if (this.live) this.live.textContent = this.errorText;
        setTimeout(() => {
          this.button.dataset.state = '';
        }, 2400);
      }
    }
  }

  if (!customElements.get('elova-product-card')) {
    customElements.define('elova-product-card', ElovaProductCard);
  }
  } catch(e) { console.error(e); }
})();

})();
